<template>
	<section class="blocks" id="block3" :style="{ background: bg_color }">
		<div class="container">
			<h2 class="title-box">{{ title }}</h2>
			<article class="article-blocks">
				<div v-html="content">
					{{ content }}
				</div>

				<figure class="left-block desktop">
					<img :src="figure" :alt="title">
				</figure>

				<figure class="mobile">
					<img :src="resp_image" :alt="title">
				</figure>

			</article>
		</div>
	</section>
</template>

<script>
    export default {
        props: ["title", "content", "figure", "bg_color", "resp_image", "bg_resp_color"]
    }
</script>

<style lang="scss">
	#block3 {

		.article-blocks {
			overflow: hidden;

			p {
				width: 90%;
				color: #222831;
				font-size: 1.6em;
				line-height: 24px;
				margin: 0 auto 25px auto;
			}
		}

		figure {
			text-align: center;
			margin-top: 0;
		}
	}

	@media (max-width: 767px) {

		#block3 {
			flex-wrap: wrap;

			h2 {
				text-align: left;

				&:after {
					left: 0;
					margin-left: 0;
				}
			}

			.article-blocks {
				p {
					width: 100%;
					text-align: left !important;
				}
			}

			figure {
				flex-basis: 100%;

				img {
					width: 92%
				}
			}

		}
	}

	@media (max-width: 640px) {
		#block3 {
			flex-wrap: wrap;

			figure {
				flex-basis: 100%;

				img {
					width: 92%
				}
			}

		}
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/blocks/Block3.vue